import * as React from "react";
import { Modal, Button } from "react-bootstrap";
import * as Routes from "lib/routes";
import I18n from "lib/I18n";
import { sessionStore } from "lib/store";
import { observer } from "mobx-react-lite";

export const SessionExpiredDialog = observer(() => {
  const store = sessionStore;

  const onRedirectToLogin = () => {
    location.href = Routes.user_session_path();
  };
  const onClose = () => {
    store.loginRequired = false;
  };

  return (
    <Modal
      className="dialog-session-expired"
      show={store.loginRequired}
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title>{I18n.t("session_expired_dialog.message")}</Modal.Title>
        <Modal.Footer>
          <Button variant="primary" onClick={onRedirectToLogin}>
            {I18n.t("session_expired_dialog.login")}
          </Button>
          <Button onClick={onClose}>
            {I18n.t("session_expired_dialog.close")}
          </Button>
        </Modal.Footer>
      </Modal.Header>
    </Modal>
  );
});
